import React from "react";
import { TryAgainBtn } from "./styles";

import { lumCalc } from "../../../../../utils/functions/lumCalc";

import TryAgainLogo from "../../../../../components/TryAgainLogo";

const ReturnButton = (props) => {

  return (
    <TryAgainBtn
      type="submit"
      onClick={props.handleBack}
      bgColor={props.bgColor || "#F1B434"}
      letterColor={lumCalc(props.bgColor || "#ffffff") > 128 ? "black" : "white"}
    >
      <TryAgainLogo bgColor={props.bgColor || "#ffffff"} />
      <strong>Tentar novamente</strong>
    </TryAgainBtn>
  );
};

export default ReturnButton;
